import axios from "axios";

export const FileService = async (presignedUrl, file) => {
    try {
        // Must match Content-Type used when the backend signed the URL
        // (e.g. Excel = application/vnd.openxmlformats-officedocument.spreadsheetml.sheet)
        const contentType = file.type || "application/octet-stream";

        const response = await axios.put(presignedUrl, file, {
            headers: {
                "Content-Type": contentType,
            },
            timeout: 60 * 1000 // 1 minute
        });

        return {
            status: "ok",
            statusCode: response.status
        };

    } catch (error) {
        console.error(error);

        if (error.code === "ECONNABORTED") {
            // Timeout case
            return {
                status: "error",
                statusCode: 408,
                message: "Upload timed out after 1 minute"
            };
        }

        return {
            status: "error",
            statusCode: error.response ? error.response.status : 500,
            message: error.message
        };
    }
};

export default FileService;